// src/campaigns/constants/campaign-og.ts

import { CampaignOG } from "../types/campaign.types";

export const DEFAULT_CAMPAIGN_OG: CampaignOG = {
  title: "LRNSY - Digital Love Experiences",
  description:
    "Create beautiful digital bouquets and love cards for your special someone. Share unique links and make moments unforgettable.",
  imagePath: "/og-image.png",
};

export function buildCampaignOG(params: {
  title: string;
  description: string;
  imageName: string;
  year: number;
}): CampaignOG {
  return {
    title: `${params.title} | LRNSY`,
    description: params.description,
    imagePath: `/og/campaigns/${params.imageName}-${params.year}.png`,
  };
}
